export default __webpack_public_path__ + "static/media/3E9A8999_.65c43176.jpg";